import React, {useRef, useState} from "react";
import APIUrls from "../../../services/APIUrls";
import {useTranslation} from "react-i18next";

import FileDragUpload from "../../global/FileDragUpload";
import Constants from "../../../Constants";
import jQuery from "jquery";
import {postAxiosResponse} from "../../../services/authApiRoutes/APImethods";

export default function UploadReviseTranslation({tmFileId, projectId, uploadEndHandler}) {

    const {t} = useTranslation();
    const translate = t;
    const uploadTmFileRef = useRef(null)
    const [isUploadingTM, setIsUploadingTM] = useState(false);
    const [translationMemoryFileID, setTranslationMemoryFileID] = useState(null)
    const [hasTmSelectedFile, setHasTmSelectedFile] = useState(null)

    function getUploadTmParams() {
        return {
            'docFileId': translationMemoryFileID,
        }
    }

    function uploadTM() {
        if (!hasTmSelectedFile) return
        setIsUploadingTM(true);
        let url = APIUrls.DOCUMENT_EDIT
        let params = {
            'name': "TM_UPLOAD",
            'project.id': projectId,
            'docType': "TM_UPLOAD"
        }
        if (tmFileId) {
            params['document.id'] = tmFileId
            url = APIUrls.DOCUMENT_FILE_METADATA;
        }
        let urlParams = new URLSearchParams(params);
        url += "?" + urlParams.toString();
        postAxiosResponse(url, {}).then(res => {
            if (res.status === 200) {
                setTranslationMemoryFileID(res.data.documentFileId);
                uploadTmFileRef.current.startUpload();
            }
        }).catch(err => {
            console.error(err)
            setIsUploadingTM(false);
            setHasTmSelectedFile(false);
        })
    }

    function onUpload(response) {
        if (response.status === 200) {
            closeModel()
            setIsUploadingTM(false)
            setHasTmSelectedFile(false)
            if (uploadEndHandler) {
                uploadEndHandler(response);
            }
            uploadTmFileRef.current.reset();
        }
    }

    const handleTmFileChange = (e) => {
        setHasTmSelectedFile(!!e.target)
    };

    const hideKeyFinishEnterflow = (event) => {
        if (event.key === Constants.ENTER) {
            closeModel();
            setHasTmSelectedFile(false)
        }
    };

    const handleKeyFinishflow = (event) => {
        if (event.key === Constants.TAB) {
            if (event.shiftKey === false) {
                event.preventDefault();
                jQuery(".first-focusEvent").trigger("focus");
            }
        }
    };

    function closeModel() {
        jQuery("body").removeClass("modal-open");
    }

    return (
        <div id="modelPopup" className="lightbox-panel tm-popup" aria-labelledby="uploadTm" aria-modal="true"
             role="dialog">
            <div className="inner-lightbox-panel">
                <div className="modal-header flex">
                    <strong id="uploadTm">
                        {translate("project_listing.upload_tm")}
                    </strong>
                </div>
                <div className="lightbox-content">
                    <div className="flex wrap-dropdown mar-bot10">
                        <div style={{width: "100%"}}>
                            <FileDragUpload ref={uploadTmFileRef}
                                            onChange={handleTmFileChange}
                                            getUploadParams={getUploadTmParams}
                                            fileDataAttribute="fileData"
                                            uploadUrl={APIUrls.REFERENCE_UPLOAD}
                                            uploadEndHandler={onUpload}>
                                <p id="descriptionHeader">Make sure you choose a valid translation memory file in TMX
                                    format. You can upload multiple TMX files in one .zip file.</p>
                            </FileDragUpload>
                        </div>
                    </div>
                </div>
                <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold first-focusEvent" onKeyDown={hideKeyFinishEnterflow}
                            disabled={isUploadingTM}
                            onClick={closeModel}>Cancel
                    </button>
                    <button className="btn btn-bold active finshBtn"
                            onKeyDown={handleKeyFinishflow}
                            disabled={isUploadingTM}
                            onClick={uploadTM}>Upload
                    </button>
                </div>
            </div>
        </div>
    );
}
